__turbopack_context__.v({
  "background_image": "styles-module-scss-module__B2Qgsq__background_image",
  "container": "styles-module-scss-module__B2Qgsq__container",
  "container_alignment_center": "styles-module-scss-module__B2Qgsq__container_alignment_center",
  "container_alignment_left": "styles-module-scss-module__B2Qgsq__container_alignment_left",
  "container_alignment_right": "styles-module-scss-module__B2Qgsq__container_alignment_right",
  "container_content": "styles-module-scss-module__B2Qgsq__container_content",
  "container_description": "styles-module-scss-module__B2Qgsq__container_description",
  "container_header": "styles-module-scss-module__B2Qgsq__container_header",
  "content_box_shadow": "styles-module-scss-module__B2Qgsq__content_box_shadow",
  "header_description_container": "styles-module-scss-module__B2Qgsq__header_description_container",
  "header_spacing_large": "styles-module-scss-module__B2Qgsq__header_spacing_large",
  "header_spacing_medium": "styles-module-scss-module__B2Qgsq__header_spacing_medium",
  "header_spacing_none": "styles-module-scss-module__B2Qgsq__header_spacing_none",
  "header_spacing_small": "styles-module-scss-module__B2Qgsq__header_spacing_small",
  "no_overflow": "styles-module-scss-module__B2Qgsq__no_overflow",
  "no_padding": "styles-module-scss-module__B2Qgsq__no_padding",
  "remove_bottom_spacing": "styles-module-scss-module__B2Qgsq__remove_bottom_spacing",
  "spacing_large": "styles-module-scss-module__B2Qgsq__spacing_large",
  "spacing_medium": "styles-module-scss-module__B2Qgsq__spacing_medium",
  "spacing_none": "styles-module-scss-module__B2Qgsq__spacing_none",
  "spacing_small": "styles-module-scss-module__B2Qgsq__spacing_small",
  "text_alignment_center": "styles-module-scss-module__B2Qgsq__text_alignment_center",
  "text_alignment_left": "styles-module-scss-module__B2Qgsq__text_alignment_left",
  "text_alignment_right": "styles-module-scss-module__B2Qgsq__text_alignment_right",
  "theme_background_gray_to_white": "styles-module-scss-module__B2Qgsq__theme_background_gray_to_white",
  "theme_background_is_black": "styles-module-scss-module__B2Qgsq__theme_background_is_black",
  "theme_background_is_gray": "styles-module-scss-module__B2Qgsq__theme_background_is_gray",
  "theme_background_is_white": "styles-module-scss-module__B2Qgsq__theme_background_is_white",
  "theme_has_background_image_with_content_box_shadow": "styles-module-scss-module__B2Qgsq__theme_has_background_image_with_content_box_shadow",
  "theme_has_grey_content_box": "styles-module-scss-module__B2Qgsq__theme_has_grey_content_box",
  "theme_has_white_content_box": "styles-module-scss-module__B2Qgsq__theme_has_white_content_box",
  "width_fixed": "styles-module-scss-module__B2Qgsq__width_fixed",
  "width_fixed_large": "styles-module-scss-module__B2Qgsq__width_fixed_large",
  "width_fixed_medium": "styles-module-scss-module__B2Qgsq__width_fixed_medium",
  "width_full": "styles-module-scss-module__B2Qgsq__width_full",
});
